<template>
  <div>
    <PageHeader page-name="Предложения">
      <template>
        <FilterPanel>
          <Filters @filter="doFilter" />
        </FilterPanel>
      </template>
    </PageHeader>
    <MainPanel>
      <List v-loading="loading" @sort="doSort" />
      <el-pagination
        v-if="meta"
        background
        :current-page="filterObject.page"
        hide-on-single-page
        layout="prev, pager, next"
        :page-size="meta.per_page"
        :total="meta.total"
        @current-change="changePage"
      />
    </MainPanel>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import List from '@/components/offers/List'
import MainPanel from '@/components/common/MainPanel'
import FilterPanel from '@/components/common/FilterPanel'
import Filters from '@/components/offers/Filters'
import PageHeader from '@/components/common/PageHeader';

export default {
  components: {Filters, FilterPanel, MainPanel, List, PageHeader},
  metaInfo: {
    title: 'Предложение',
  },
  data() {
    return {
      loading: false,
      filterObject: {
        page: 1,
      },
    }
  },
  computed: {
    ...mapState('offers', [
      'offers',
    ]),
    meta() {
      return this.offers?.meta
    },
  },
  methods: {
    ...mapActions('offers', [
      'fetchOffers',
    ]),
    async getOffers() {
      this.loading = true
      await this.fetchOffers(this.filterObject)
      this.loading = false
    },
    changePage(page) {
      this.filterObject.page = page
      this.getOffers()
    },
    doFilter(filters) {
      this.filterObject = {...this.filterObject, ...filters}
      this.filterObject.page = 1
      this.getOffers()
    },
    doSort(sort) {
      this.filterObject = {...this.filterObject, ...sort}
      this.filterObject.page = 1
      this.getOffers()
    },
  },
}
</script>
